<template>
    <div class="hero-item flex-y hero-item animate__animated animate__fadeIn" :style="{ backgroundImage: `url('${this.image}')` }" @mouseout="this.active = false"  @mouseover="this.active = true">

        <div class="hero-inner-container flex-y center-x center-y" v-show="this.active == true">
            <h1 class="hero-title">{{ data.name ?? data.title }}</h1>

            <hr style="color: white; width: 100%;">

            <h2 class="hero-date" v-text="Timestamp"></h2>

            <p v-if="data.custom_text != undefined" class="custom-text">{{ data.custom_text }}</p>

            <div v-if="data.type == 'altlan'" style="width: 100%;">
                <div class="flex-x hero-button-container my-2">
                    <button type="submit" class="btn btn-warning hero-button"><a href="/shop/tickets"><i class="fas fa-ticket-alt"></i> Get Tickets</a></button>
                    <button type="submit" class="btn btn-warning mx-2 hero-button"><a href="/altlan"><i class="fas fa-info-circle"></i> More Info</a></button>
                </div>
            </div>

            <div v-if="data.type == 'other'" style="width: 100%;">
                <div class="flex-x hero-button-container my-2">
                    <button type="submit" class="btn btn-warning hero-button">
                        <a :href="`/event/${data.slug}`"><i class="fas fa-info-circle"></i> More Info</a>
                    </button>
                </div>
                <div class="flex-x"></div>
            </div>

        </div>

    </div>
</template>

<script>

import moment from 'moment';

export default {

    data () {
        return {
            image: "",
            active: false
        }
    },

    props: ['data', 'index'],

    created () {

        this.image = window.location.href + 'storage/';

        if ( typeof this.data.custom_image !== 'undefined' ) {
            this.image += this.data.custom_image;
        } else if ( typeof this.data.thumbnail !== 'undefined' ) {
            this.image += this.data.thumbnail;
        } else {
            this.image += this.data.images[0].path;
        }

    },

    computed: {
        Timestamp: function () {
            if ( this.data.start_date != undefined ) return moment(this.data.start_date).format('MMM Do, h:mm A');
            else return "";
        }
    }

}
</script>